export * from "./QuizResultOrder";
